export interface IGmbTimeRange {
  startTime: string;
  endTime: string;
}

export interface IGmbTimeDimension {
  timeRange: IGmbTimeRange;
}

export interface IGmbTotalValue {
  metricOption: string;
  timeDimension: IGmbTimeDimension;
  value: string;
}

export interface IGmbMetricValue {
  metric: GmbMetricType;
  totalValue: IGmbTotalValue;
}

export type GmbMetricType =
  | 'QUERIES_DIRECT'
  | 'QUERIES_INDIRECT'
  | 'QUERIES_CHAIN'
  | 'VIEWS_MAPS'
  | 'VIEWS_SEARCH'
  | 'ACTIONS_WEBSITE'
  | 'ACTIONS_PHONE'
  | 'ACTIONS_DRIVING_DIRECTIONS'
  | 'PHOTOS_VIEWS_MERCHANT'
  | 'PHOTOS_VIEWS_CUSTOMERS'
  | 'PHOTOS_COUNT_MERCHANT'
  | 'PHOTOS_COUNT_CUSTOMERS'
  | 'LOCAL_POST_VIEWS_SEARCH';

export interface IGmbLocationMetric {
  locationName: string;
  timeZone: string;
  metricValues: IGmbMetricValue[];
}

export interface IGmbAnalytics {
  locationMetrics: IGmbLocationMetric[];
}

export interface IStoreAnalytics {
  status: string;
  general_stats: any[]
  device_stats?: any;
  city_stats?: any;
}

export interface IDataAnalytics {
  sessions?: number;
  pageViews: number;
  avgTimeOnPage: number;
  organicSearches: number;
  exits: number;
}


export interface IGMBReviews {
  reviews?: any[]
  averageRating?: number;
  totalReviewCount?: number;
}
